import { SYM_SPECIAL_DEPS } from "../../enum/Symbol";
import useQueryParentLayer from "../../layer/chain/store/useStoreLayerParent";
import useQueryOriginalSourceByLayer from "../../layer/chain/store/useStoreOriginalSource";
import useQueryRootLayer from "../../layer/chain/store/useStoreRootLayer";
import { useQueryLayer1 } from "../../layer/chain/useQueryLayer";
import { useQueryOriginSource } from "../../layer/chain/useQueryOriginal";
import useOnLayerAfterSet from "../../layer/observable/useOnLayerAfterSet";
import useOnOriginalSourceChanged from "../../layer/observable/useOnOriginalSourceChanged";
import useLogStack from "../../layer/utils/useLogStack";
import { useSubscribeDOMDestroyed, useSubscribeDOMRendered } from "../../observer/useDomObserver";
import useDiscard from "../../useDiscard";
import useDebouncing from "../../utils/useDebouncing";
import useWeakMap from "../../utils/useWeakMap";
import { isPropContainKey, queryAllChilds } from "../util";
import { initLayerSwapper } from "../utils/useLayerSwapper";


const storeWatcher = useWeakMap();

window.storeWatcher = storeWatcher

const usePropStore = (() => {

    const wmChildParent = useWeakMap();
    const wmParentChild = useWeakMap();

    const onDiscardParent = (prop) => {
        wmParentChild.delete(prop)
    }

    const onDiscardChild = (prop) => {
        wmChildParent.delete(prop)
    }

    const instance = {
        addProps: (propsParent, propChild) => {
            wmChildParent.set(propChild, propsParent);
            const childs = wmParentChild.get(propsParent) || new Set();
            childs.add(propChild);
            wmParentChild.set(propsParent, childs);
            useDiscard(propsParent, onDiscardParent)
            useDiscard(propChild, onDiscardChild)
        },
        getPropParent: (props) => {
            return wmChildParent.get(props);
        },
        getPropChilds: (props) => {
            return wmParentChild.get(props);
        },
        changePropParent: (propsChild, propsParent) => {

        }
    }

    return () => instance;
})()

const useWatcher = (() => {

    const runQueue = (() => {
        const stack = []
        return (fn) => {
            fn.call(null);
            // stack.push(fn);
            // if (tv == null) {
            //     tv = setTimeout(() => {
            //         while (stack.length > 0) {
            //             stack.shift().call(null);
            //         }
            //         tv = null;
            //     }, 0)
            // }
        }
    })();

    /** @type {fnTemplateWatcher} */
    const newAction = (props, node, propNameDeps) => {

        // if(props?)
        // if (props?.item?.child) debugger;

        const
            fnCreated = [],
            fnDestroy = [],
            fnPropChanges = [];


        let _hasCreated = false, _hasDestroy = false, _hasCallFirstChanges = false;

        const hasCreated = () => _hasCreated || document.body.contains(node);

        const emitChanges = (props, keyChanges) => {
            if (!_hasCreated) {
                return;
            }
            _hasCallFirstChanges = true;
            for (let i in fnPropChanges) {
                fnPropChanges[i].call(null, props, keyChanges);
            }
        }

        const emitCreated = () => {
            for (let i in fnCreated) {
                fnCreated[i].call(null);
            }
        }

        const emitDestroyed = () => {
            for (let i in fnDestroy) {
                fnDestroy[i].call(null);
            }
        }

        const onCreated = (fn) => {
            if (typeof fn !== 'function') { throw "Only allow function" }
            fnCreated.push(fn);
            if (hasCreated()) {
                fn.call(null);
            }
        }

        const onPropChanges = (fn) => {
            if (typeof fn !== 'function') { throw "Only allow function" }
            fnPropChanges.push(fn);
            if (hasCreated()) {
                fn.call(null);
            }
        }

        const onDestroy = (fn) => {
            if (typeof fn !== 'function') { throw "Only allow function" }
            fnDestroy.push(fn);
            if (_hasDestroy) {
                fn.call(null);
            }
        }

        const subcribePropParentChanges = (propNameDeps = [], fn, props) => {
            const { getPropParent } = usePropStore();
            const parentProp = getPropParent(props);
            // const parentProp = useQueryParentLayer(props)
            if (!parentProp) {
                return
            }

            const propNameNeedFollowParent = propNameDeps.reduce((out, k) => {
                if (!isPropContainKey(props, k)) {
                    out.push(k);
                }
                return out;
            }, [])

            let unsub;

            if (propNameNeedFollowParent.length > 0) {

                onCreated(() => {
                    // debugger
                    const layer1 = useQueryLayer1(parentProp) || parentProp
                    unsub = useOnLayerAfterSet(layer1, (propertyPath, absKey, key, value) => {
                        emitChanges(props, key)
                    }, propNameNeedFollowParent);
                    onDestroy(unsub)
                })

            }
            return () => {
                if (typeof unsub === 'function') {
                    unsub();
                }
            }
        }

        const subcribeEvents = (props) => {
            let unsubcribeChanges, unsubParent;
            const unsubRender = useSubscribeDOMRendered(node, () => {
                _hasCreated = true;
                _hasDestroy = false;
                emitCreated();
                unsubParent = subcribePropParentChanges(propNameDeps, emitChanges, props)

                const layer1 = props
                if (SYM_SPECIAL_DEPS in props && Array.isArray(props[SYM_SPECIAL_DEPS])) {
                    propNameDeps.push(...props[SYM_SPECIAL_DEPS]);
                }

                const unsubcribeChanges = useOnLayerAfterSet(layer1, (propertyPath, absKey, key, value) => {
                    useLogStack("useWatcher", props, { absKey, key, value })
                    emitChanges(props, key)
                }, propNameDeps)

                onDestroy(unsubcribeChanges);

                if (!_hasCallFirstChanges) {
                    emitChanges(props);
                }
            }, null, props)

            const doDestroy = () => {
                if (_hasDestroy) return;
                _hasCreated = false;
                _hasDestroy = true;
                _hasCallFirstChanges = false;
                if (unsubcribeChanges) {
                    unsubcribeChanges();
                }
                emitDestroyed();
            }

            const unsubDestroy = useSubscribeDOMDestroyed(node, doDestroy, null, props);
            const unsubDiscard = useDiscard(props, doDestroy)

            if (hasCreated()) {
                unsubParent = subcribePropParentChanges(propNameDeps, emitChanges, props)
            }

            return () => {
                unsubDestroy();
                unsubDiscard();
                unsubcribeChanges();
                unsubRender();
                if (unsubParent) {
                    unsubParent();
                }
            }
        }

        const getLayer = () => props

        const getSource = () =>  props;

        let unsubAlls = subcribeEvents(props);

        const reRun = () => {
            if (_hasCreated) return;
            unsubAlls = subcribeEvents(props);
        }

        // const { onSwapped } = initLayerSwapper(props);
        // onSwapped(swappedLayer => {
        //     console.log("swapper layer", swappedLayer)
        //     props = swappedLayer;
        //     unsubAlls();
        //     subcribeEvents(props);
        // })

        return {
            onCreated,
            onDestroy,
            onPropChanges,
            getLayer,
            getSource,
            reRun
        }
    }

    const onDiscardProp = (p) => { storeWatcher.delete(p) }

    /** @type {fnTemplateWatcher} */
    return (props, node, propNameDeps) => {
        if (!storeWatcher.has(props)) {
            storeWatcher.set(props, useWeakMap())
            useDiscard(props, onDiscardProp)
        }
        if (!storeWatcher.get(props).has(node)) {
            storeWatcher.get(props).set(node, [])
        }
        const instance = newAction(props, node, propNameDeps);
        storeWatcher.get(props).get(node).push(instance);
        // storeWatcher.set(props, newAction(props, node, propNameDeps))
        return instance;
    }
})()

const hasRendered = (node) => document.body.contains(node);

export const reRunWatcher = (props, node) => {
    if (storeWatcher.has(props) && storeWatcher.get(props).has(node)) {
        const instances = storeWatcher.get(props).get(node)
        for (let i in instances) {
            if (hasRendered(node)) {
                instances[i].reRun();
            }
        }
    }
}

export default useWatcher;

export { usePropStore }